export default {
  loginButton: 'Sign In',
  version: 'Version',
};
